module.exports = __webpack_public_path__ + "static/media/ic_add_circle_outline.3f503268.svg";